import { render, staticRenderFns } from "./SortableMarker.vue?vue&type=template&id=f781d7c8"
import script from "./SortableMarker.vue?vue&type=script&lang=js"
export * from "./SortableMarker.vue?vue&type=script&lang=js"
import style0 from "./SortableMarker.vue?vue&type=style&index=0&id=f781d7c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports